import { gqlClient } from 'services/api/gql/gqlClient';
import { ActiveClientCampaigns } from 'constants/gql/queries/advocacy/activeClientCampaigns.gql';
import { ERROR } from 'components/Campaigns/Referrer/constants';

/**
 * Fetches the signed-in referrer's active client campaign(s) from RMS.
 *
 * @param {Object} payload
 * @param {string} payload.clientId - Referrer's BI account ID.
 * @param {string} [payload.referrerFirstName]
 * @param {string} [payload.referrerLastName]
 * @returns {Promise<Array<Object>>} Active campaigns; [] when the promotion has ended.
 * @throws {{ errors: [{ errorCode: string }] }} CUSTOM_ADVOCACY_DOWN on missing data / failure.
 */
async function activeClientCampaigns({ clientId, referrerFirstName, referrerLastName }) {
    const { country } = Sephora.renderQueryParams;

    try {
        const data = await gqlClient.query({
            headers: { 'x-source': 'ufe' },
            operationName: 'ActiveClientCampaigns',
            query: ActiveClientCampaigns,
            variables: {
                input: {
                    clientId,
                    country,
                    channel: 'DIGITAL',
                    device: 'WEB',
                    userType: 'CLIENT',
                    referrerFirstName,
                    referrerLastName
                }
            }
        });

        const result = data?.activeClientCampaigns;

        if (result == null) {
            throw { errors: [{ errorCode: ERROR.CUSTOM_ADVOCACY_DOWN }] };
        }

        return result;
    } catch (err) {
        const errorCode = err?.errors?.[0]?.errorCode;
        const rawMessage = (typeof err?.cause === 'string' ? err.cause : err?.cause?.message) || err?.errors?.[0]?.message || err?.message;
        Sephora.logger.warn('[advocacy/activeClientCampaigns] GraphQL error:', errorCode, rawMessage);

        throw err?.errors ? err : { errors: [{ errorCode: ERROR.CUSTOM_ADVOCACY_DOWN }] };
    }
}

export default activeClientCampaigns;
